import { db } from '../main';
import { stage } from '../../appConfig';

const state =  {
	auth: false,
	appointment: null,
};

const mutations = {
	SET_APPOINTMENT (state, payload) {
        state.appointment = payload;
	},
};

const actions = {
    setAppointment({commit}, payload){
		
		return new Promise((resolve, reject) => {
			commit("SET_APPOINTMENT", payload);
				resolve();
            // if(payload) {
			// 	commit("SET_APPOINTMENT", payload);
			// 	resolve();
			// } else {
			// 	reject();
			// }
        });
	},
};

const getters = {
    appointment: state => state.appointment
}

export default {
	state,
	mutations,
	actions,
	getters
};